import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';

interface UpdateOrganizationGroupParams {
  teamId: number;
  payload: {
    name?: string;
    description?: string;
  };
}

export const useUpdateOrganizationGroup = () => {
  const queryClient = useQueryClient();

  const updateOrganizationGroup = async ({
    teamId,
    payload
  }: UpdateOrganizationGroupParams) => {
    const url = PUT_URL(teamId.toString()).updateTeam;
    const response = await Axios.put(url, payload);
    return response.data;
  };

  return useMutation(updateOrganizationGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries(['teams']);
    }
  });
};
